import script from "./ExIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ExIcon.vue?vue&type=script&setup=true&lang=js"

export default script